import { IconHome, IconLeak, IconMore, IconWaterAccount } from '@assets/icons'
import { Flex } from '@chakra-ui/react'
import { Text } from '@components/Common'
import { ROUTE_PATHS } from '@routes/index'
import { LodashUtils } from '@utils/lodash'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const ROUTES = [
  {
    title: 'Dashboard',
    icon: <IconHome />,
    path: ROUTE_PATHS.DASHBOARD,
  },
  {
    title: 'Accounts',
    icon: <IconWaterAccount />,
    path: ROUTE_PATHS.WATER_ACCOUNT,
  },
  {
    title: 'Leaks',
    icon: <IconLeak />,
    path: ROUTE_PATHS.LEAKS,
  },
  {
    title: 'More',
    icon: <IconMore />,
    path: ROUTE_PATHS.RESOURCES,
  },
]

export default function NavbarMobile() {
  const [activeRoute, setActiveRoute] = useState(ROUTES[0].path)
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    setActiveRoute(location.pathname)
  }, [location])

  return (
    <Flex
      position="fixed"
      bottom="0"
      width="100%"
      zIndex={20}
      p="14px 14px 9px 14px"
      bg="white"
      shadow="0px -2px 30px rgba(0, 0, 0, 0.07)"
    >
      {ROUTES.map((route) => {
        const active = route.path === activeRoute
        return (
          <Flex
            data-testid="nav-mobile-button"
            key={route.path}
            flex={1}
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
            p="0 5px"
            cursor="pointer"
            sx={
              active
                ? {
                    svg: {
                      path: { fill: 'primary.blue' },
                      rect: { fill: 'primary.blue' },
                    },
                  }
                : undefined
            }
            onClick={LodashUtils.wrap(route.path as any, navigate)}
          >
            {route.icon}
            <Text color={active ? 'primary.blue' : 'grey.100'}>
              {route.title}
            </Text>
          </Flex>
        )
      })}
    </Flex>
  )
}
